import React from 'react';

export function SectionIndicators({ currentSection }) {
  // 7 sections: Hero, Player, Explain, Message, Features, Donation, Footer
  const totalSections = 7;

  const indicatorColor = 'rgb(255, 255, 255)';
  const borderColor = 'rgba(255, 255, 255, 0.4)';

  // Clamp currentSection to valid range (last indicator stays active for section 4+)
  const activeSection = Math.min(currentSection, totalSections - 1);

  return (
    <div className="fixed left-3 sm:left-4 md:left-6 top-0 bottom-0 z-40 flex flex-col items-center justify-center gap-2">
      {Array.from({ length: totalSections }).map((_, index) => (
        <button
          key={index}
          onClick={() => {
            window.scrollTo({
              top: index * window.innerHeight,
              behavior: 'smooth'
            });
          }}
          className="w-1.5 h-1.5 rounded-full border transition-all duration-300 hover:scale-150 active:scale-150 flex items-center justify-center"
          style={{
            backgroundColor: activeSection === index ? indicatorColor : 'transparent',
            borderColor: borderColor,
            borderWidth: '1px',
            transform: activeSection === index ? 'scale(1.5)' : 'scale(1)',
            touchAction: 'manipulation',
            opacity: activeSection === index ? 1 : 0.6
          }}
          aria-label={`Gehe zu Sektion ${index + 1}`}
        />
      ))}
    </div>
  );
}
